import React from 'react';
import { LoginContext } from '../contexts/LoginContext';

export const useLogin = () => {
    return React.useContext(LoginContext);
};
